import React, { useState, useEffect, createRef } from 'react';
import { View, TextInput, Text } from 'react-native';
import { Feather, Ionicons, Entypo } from '@expo/vector-icons';
import he from 'he';
import { stylesInput } from './styles';

const Input = React.forwardRef(({
	placeholder,
	children,
	value,
	onChangeText,
	onChange,
	onSubmitEditing,
	autoCapitalize,
	returnKeyType,
	returnKeyLabel,
	textContentType,
	secureTextEntry,
	keyboardType,
	autoCompleteType,
	error,
	onBlur = () => {},
    editable = true
}, ref) => {
	const currentValue = value ? he.decode(value) : '';
	const [active, setActive] = useState(currentValue.length > 0);
    const [isShow, setIsShow] = useState(secureTextEntry);
	const inputRef = ref || createRef();
	useEffect(() => {
		setActive(currentValue.length > 0 || inputRef.current.isFocused());
	}, [currentValue]);


	return (
		<View style={[stylesInput.container, active && stylesInput.active]}>
			<Text
				style={[
					stylesInput.placeholder,
					error && stylesInput.placeholderError,
					active && stylesInput.labelActive,
					!active && stylesInput.labelInactive,
				]}
				onPress={() => inputRef.current.focus()}
				onFocus={() => inputRef.current.focus()}
			>
				{children || placeholder}
			</Text>
			<TextInput
				style={[stylesInput.input, error && stylesInput.inputError]}
				value={currentValue}
				onChangeText={onChangeText}
				onChange={onChange}
				onFocus={() => setActive(true)}
				onBlur={() => { setActive(currentValue.length > 0); onBlur(); }}
				ref={inputRef}
				onSubmitEditing={onSubmitEditing}
				keyboardAppearance="dark"
				autoCapitalize={autoCapitalize}
				returnKeyType={returnKeyType}
				returnKeyLabel={returnKeyLabel}
				textContentType={textContentType}
				secureTextEntry={secureTextEntry && isShow}
				keyboardType={keyboardType}
				editable={editable}
			/>
			{autoCompleteType == 'password' && (
			  <Ionicons
				style={[stylesInput.icon]}
				name={isShow ? 'ios-eye' : 'ios-eye-off'}
				onPress={() => {
				  setIsShow(!isShow);
				}}
				size={20}
				color="#000"
			  />
			)}
		</View>
	);
});

export default Input;
